import React from "react";
import classNames from "classnames";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, UncontrolledDropdownProps } from "Components/ReactstrapSlim";
import { ReservationCalendarWorkspaceModel } from "Services/API/API";
import WorkspaceSelectorItem, { useDuplicatedNames } from "./WorkspaceSelectorItem";

interface WorkspaceSelectorProps extends Omit<UncontrolledDropdownProps, "onChange"> {
   workspaces: ReservationCalendarWorkspaceModel[];
   value: Guid | undefined;
   onChange: (workspace: ReservationCalendarWorkspaceModel) => void;
}

const WorkspaceSelector: React.FC<WorkspaceSelectorProps> = ({ workspaces, value, onChange, ...rest }) => {
   const duplicatedNames = useDuplicatedNames(workspaces);

   const selectedWorkspace = value ? workspaces.find(x => x.workspace.id == value) : undefined;

   return (<UncontrolledDropdown {...rest}>
      <DropdownToggle className="rcm-workspaces-dropdown-toggle" caret disabled={!workspaces.length || rest.disabled}>
         {selectedWorkspace
            ? <WorkspaceSelectorItem workspace={selectedWorkspace.workspace} duplicatedNames={duplicatedNames} />
            : <div className="rcm-workspaces-dropdown-placeholder">{workspaces.length ? "Choose a space" : "No spaces avaialable for this date"}</div>}
      </DropdownToggle>
      <DropdownMenu className="rcm-workspaces-dropdown-menu">
         {
            workspaces.map(workspace => <DropdownItem key={workspace.workspace.id} onClick={() => onChange(workspace)} className={classNames("rcm-workspaces-dropdown", { "rcm-workspaces-dropdown--selected": value == workspace.workspace.id })}>
               <WorkspaceSelectorItem workspace={workspace.workspace} duplicatedNames={duplicatedNames} />
            </DropdownItem>)
         }
      </DropdownMenu>
   </UncontrolledDropdown>)
}

export default WorkspaceSelector;